<template>
  <a
    class="probablility_footer_anchor"
    v-if="nationPath === 'jp'"
    href="https://now.nexon.com/service/hittheworld?page=6563f23a-c9f6-4d6f-81c3-8469943343d0"
    target="_blank"
  >
    {{ $t('nav.bottom.probability_notification_B04') }}
    <img src="../../assets/images/ico_open_in_new.png" width="14" alt="" />
  </a>
</template>
<script>
import { getBaseInfo } from '@/utils'

export default {
  data() {
    return {
      nationPath: 'kr'
    }
  },
  methods: {},
  mounted() {
    const { nationPath } = getBaseInfo()
    this.nationPath = nationPath
  }
}
</script>
<style lang="scss" scoped>
.probablility_footer_anchor {
  display: flex;
  max-width: 1024px;
  margin: 0 auto;
  background-color: white;
  border-top: 1px solid #e5e5e5;
  height: 55px;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  color: #000;
  text-decoration: none;
  img {
    margin-left: 3px;
    width: 12px;
    height: 12px;
  }
}
</style>
